import { Injectable } from '@angular/core';
import { NgbDatepickerI18n } from '@ng-bootstrap/ng-bootstrap';

/**
 * @version $Id: custom.ngbdatepickeri18n.ts 52286 2017-06-23 23:20:45Z sandro.c.simas $
 */
@Injectable()
export class CustomNgbDatepickerI18n extends NgbDatepickerI18n {

  private static readonly WEEKDAYS = ['Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sab', 'Dom'];
  private static readonly MONTHS = ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'];

  constructor() {
    super();
  }

  getWeekdayName(weekday: number): string {
    return CustomNgbDatepickerI18n.WEEKDAYS[weekday - 1];
  }
  getMonthName(month: number): string {
    return CustomNgbDatepickerI18n.MONTHS[month - 1];
  }
}


// WEBPACK FOOTER //
// ./src/app/utils/custom.ngbdatepickeri18n.ts